module.exports = __webpack_public_path__ + "img/4.fcaf53a0.png";